import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SmartLoader, SmartSoftButton } from "soft_digi";
import { TASK_API_URLS } from "../../api/TaskApiUrls";
import DscCheckAlert from "../../components/site/DscCheckAlert";
import ReactPdfViewer from "../../components/site/ReactPdfViewer";
import TimerDisplay from "../../components/site/TimerDisplay";
import { useSiteContext } from "../../contexts/SiteProvider";
import { post } from "../../services/smartApiService";
import config from "../../config/config";
const CERT_URL = config.CLIENT_URL || "";
const DigiSignSingle = () => {
  const timerSeconds = 5;
  const [data, setData] = useState<any>({});
  const [input, setInput] = useState<any>(null);
  const [timer, setTimer] = useState(0);
  const [countdown, setCountDown] = useState(10000);
  const [redirectUrl, SetRedirectUrl] = useState<string | null>(null);
  const { setLoading, openModal } = useSiteContext();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const timeOut = 3000;
  const fileName = "Staticpdf.pdf"; // Desired file name
  const [cert, setSignedCert] = useState<any>({});

  const DscSelectionOrAlert = (data_in: any, type = "REGISTER") => {
    let modalObject = {
      title: "DSC Selection/Registration",
      content: (
        <DscCheckAlert
          dataIn={data_in}
          loadData={getOne}
          setSignedCert={setSignedCert}
          type={type}
        />
      ),
      closeModal: false,
      modalClass: "smart-modal-60",
    };
    openModal(modalObject);
  };

  const getOne = () => {
    const subscription = post(TASK_API_URLS.GET_ONE, { id: token }).subscribe(
      (response) => {
        // setting the data object
        setData(response.data.data);
        const base64String = response.data.data?.content;
        const fileObject = base64ToFile(base64String, fileName);
        // setting the preview file
        setInput(fileObject);
        //
        if (response.data.data.empDsc.length !== 1) {
          DscSelectionOrAlert(response.data.data, "REGISTER");
        } else if (response.data.data.empDsc.length === 1) {
          DscSelectionOrAlert(response.data.data, "CHECK");
          //  setSignedCert(response.data.data.empDsc[0],"CHECK");
        }
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    //  console.log("toekn " , token);
    if (token) {
      getOne();
    }
  }, [token]);

  /**
   *
   */
  const navigateBack = () => {
    // let url = data?.redirect_url + "token=" + token;
    // window.location.href = url;
    // "http://localhost:4000"
    window.close();
  };

  useEffect(() => {
    // get the redirect url from data directory with token
    if (countdown < 1) {
      //navigateBack();
      //let url = data?.redirect_url;
      //window.location.href = url;
      // return;
    }
  }, [countdown]);

  const successFunction = () => {
    window.opener.postMessage("sdsSignOperationCompleted", data?.redirect_url);
  };

  useEffect(() => {
    if (timer === 0 && redirectUrl) {
      successFunction();
      //window.location.href = redirectUrl;
      return;
    }
  }, [timer]);

  useEffect(() => {
    // Set up the interval to decrease the time left by one every second
    const timerId = setInterval(() => {
      setTimer((prevTime) => prevTime - 1);
    }, 1000);
    // Clean up the interval on component unmount
    return () => clearInterval(timerId);
  }, [setTimer]);

  const postData = async (url: string, data: any): Promise<any> => {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    return response.json(); // Assumes the response is JSON
  };

  const base64ToFile = (base64String: string, fileName: string) => {
    const binaryString = atob(base64String);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([bytes], { type: "application/pdf" });
    return new File([blob], fileName, { type: "application/pdf" });
  };

  const embedPdf = (content: String) => {
    // setLoading(true, "PDF Signing..");
    const payload = { id: token, content: content };
    const subscription = post(TASK_API_URLS.EMBED_HASH, payload, {
      showLoading: false,
    }).subscribe((response) => {
      setLoading(false);
      setData(response.data.data);
      const base64String = response.data.data?.content;
      const fileName = "Staticpdfsigned.pdf"; // Desired file name
      const fileObject = base64ToFile(base64String, fileName);
      setInput(fileObject);
      let url = response.data.data?.redirectUrl + "token=" + token;
      SetRedirectUrl(url);
      SmartLoader.hideLoader();
      setTimer(timerSeconds);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const handleHash = async (content: string) => {
    const requestBody = {
      sessionId: "string",
      hashBase64: content,
      certificateSubject: cert.dsc_dn,
    };

    try {
      const result = await postData(CERT_URL + "/Sign/sign", requestBody);
      if (result.signedHashBase64) {
        embedPdf(result.signedHashBase64);
      }
      // signedHashBase64
      // console.log(" reseut ", result);
    } catch (err) {
      SmartLoader.hideLoader();
      DscSelectionOrAlert(data, "CHECK");
      //console.log(" error ", err);
    }
  };

  const signPdf = () => {
    SmartLoader.showLoader("Digital Signing.... Please Wait");
    const payload = { id: token, pem: cert.dsc_cert_pem };
    const subscription = post(TASK_API_URLS.GET_HASH_SIGN, payload, {
      showLoading: false,
    }).subscribe((response) => {
      //  setLoading(false);
      console.log("response ", response.data.data);
      handleHash(response.data.data.content);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const DisplayHeader = () => {
    return (
      <div className="columns is-vcentered is-gapless m-0">
        <div className="column has-background-success-light pl-5 is-3">
          <span className="icon-text is-size-6 has-text-success">
            <span className="icon mr-3">
              <i className="fa fa-signature"></i>
            </span>
            <span className="">DIGITAL SIGNATURE</span>
          </span>
        </div>
        <div className="column is-6">
          <span>{data?.task_name || ""}</span>
          <span className="">{data?.description}</span>
          <span className="">{data?.type}</span>
        </div>
        <div className="column is-3 is-flex is-flex-direction-column">
          <table className="table is-narrow is-size-7">
            <tr>
              <td>Name:</td>
              <td>{data?.task_user_name || ""}</td>
              <td>ID:</td>
              <td>{data?.task_user_id || ""}</td>
              <td>Time(Remaining):</td>
              <td>
                <TimerDisplay
                  targetTime={data?.task_created_time}
                  additionalSeconds={timeOut}
                  setCountDown={setCountDown}
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
    );
  };

  const displayCertificateDetails = () => {
    return (
      cert?.dsc_cn && (
        <>
          <table className="is-size-7">
            <tr>
              <td colSpan={2}>Certificate Details:</td>
            </tr>
            <tr>
              <td>CN</td>
              <td>{cert?.dsc_cn}</td>
            </tr>
            <tr>
              <td>Expiry Date</td>
              <td>{cert?.dsc_not_after}</td>
            </tr>
          </table>
        </>
      )
    );
  };

  return (
    <>
      {DisplayHeader()}
      <div className="has-background-white p-2 pb-3">
        <ReactPdfViewer pdfFile={input} bodyClass="pdf-viewer-ds" />
        {/* <SmartPdfViewer content={data?.template} /> */}
      </div>
      <div className="columns is-gapless">
        <div className="column is-5">{displayCertificateDetails()}</div>
        <div className="column is-7">
          <SmartSoftButton
            label="SIGN"
            leftIcon="fa-signature"
            classList={["button is-primary px-6"]}
            onClick={signPdf}
          />
          <SmartSoftButton
            label="CANCEL"
            leftIcon="fa-signature"
            classList={["button is-danger px-6 ml-5"]}
            onClick={navigateBack}
          />
          {timer > 0 && <p>You Will be redirected With in {timer} seconds </p>}
        </div>
      </div>
    </>
  );
};
export default DigiSignSingle;
